import { Col, Row, TimePicker } from 'antd';
import React from 'react';
import { TIME_FORMAT } from '../../../constants';
import './Location.scss';
import dayjs from 'dayjs';

const TimesForDay = ({ title, onChangeStartTime, onChangeEndTime, isValid, start, end }) => {
  return (
    <div className="hour-times">
      <Row gutter={8}>
        <Col span={7}>
          <p className="verticalCenter">{title}</p>
        </Col>
        <Col span={8}>
          <TimePicker
            onChange={onChangeStartTime}
            className="verticalCenter"
            format={TIME_FORMAT}
            size="large"
            defaultValue={start ? dayjs(start, TIME_FORMAT) : dayjs('00:00', TIME_FORMAT)}
          />
        </Col>
        <Col span={1}>
          <div className="line-wrapper">
            <div className="line"></div>
          </div>
        </Col>
        <Col span={8}>
          <TimePicker
            onChange={onChangeEndTime}
            className="verticalCenter"
            format={TIME_FORMAT}
            size="large"
            defaultValue={end ? dayjs(end, TIME_FORMAT) : dayjs('00:00', TIME_FORMAT)}
          />
        </Col>
        {!isValid && (
          <>
            <Col span={7}></Col>
            <Col span={17}>
              <p style={{ color: 'red' }}>End time must be after start time</p>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default TimesForDay;
